module.exports = __webpack_public_path__ + "static/SharpSans-Medium-8e3bdf61dcdd17550872e20e3719d63b.otf";